import React from 'react'
import { Skeleton, SkeletonProps } from 'src/antd'
import styled from 'styled-components'

import { toCssUnit } from 'src/utils/others'

export const StyledSkeletonInput = styled(Skeleton.Input)<{
  width?: number | string
}>`
  &.ant-skeleton-width-full {
    width: 100% !important;
  }

  &.ant-skeleton-bordered {
    border-radius: 4px;
  }

  /* Both renderings: src/antd/Skeleton is antd's Skeleton with the design
     toggle off and shadcn's with it on, and the shadcn half keys its parts by
     data-slot rather than re-emitting .ant-skeleton-* (its header says
     why antd's names cannot be re-emitted while antd is still installed). The
     ant-skeleton-width-full / -bordered names above are this repo's OWN
     className, not antd's, so they pass through unchanged in both modes. */
  &.ant-skeleton-element,
  &[data-slot='skeleton-element'] {
    display: flex;
  }

  ${({ width }) =>
    width
      ? `
    &.ant-skeleton-element,
    &[data-slot='skeleton-element'] {
      width: ${toCssUnit(width)};
      .ant-skeleton-input,
      [data-slot='skeleton-input'] {
        width: ${toCssUnit(width)};
        min-width: ${toCssUnit(width)};
      }
    }
  `
      : ``}
`

type TSize = `large` | 'default' | 'small'

const sizeValue: Record<TSize, string> = {
  default: '32px',
  small: '24px',
  large: '40px',
}

type TStyledSkeletonProps = {
  /**
   * Size props
   * Set heights of the following elements
   * ant-skeleton-title, and ant-skeleton-paragraph > li
   */
  size?: TSize
  sizeOverwrite?: string
}

const SkeletonStyle = styled(Skeleton)<TStyledSkeletonProps>`
  &.ant-skeleton-width-full {
    width: 100% !important;
  }
  /* Both renderings — see StyledSkeletonInput above. */
  .ant-skeleton-title,
  [data-slot='skeleton-title'] {
    height: ${({ size = 'default' }) => sizeValue[size]};
    ${({ sizeOverwrite }) =>
      sizeOverwrite ? `height: ${toCssUnit(sizeOverwrite)};` : ``}
  }
  .ant-skeleton-paragraph > li,
  [data-slot='skeleton-paragraph'] > li {
    height: ${({ size = 'default' }) => sizeValue[size]};
    ${({ sizeOverwrite }) =>
      sizeOverwrite ? `height: ${toCssUnit(sizeOverwrite)};` : ``}
  }
  /* The shadcn half sizes each row on the bar INSIDE the <li>, so the height
     above needs to reach it too — the antd half draws the row on the <li>. */
  [data-slot='skeleton-paragraph'] > li > [data-slot='skeleton-paragraph-row'] {
    height: 100%;
  }
`

export const StyledSkeleton = ({
  ...props
}: TStyledSkeletonProps & SkeletonProps) => {
  return <SkeletonStyle {...props} />
}
